import type * as React from 'react';
import classNames from 'classnames';
import { SectionTitle as SectionTitleIO } from '@doda/io-react/common';
import styles from './index.module.scss';

/**
 * Props
 */
interface SectionTitleProps {
  /** タイトル */
  children: React.ReactNode;
  /** 下部ボーダーの有無 */
  border?: boolean;
  /** 下部余白 */
  mb?: 'S' | 'M' | 'L';
  /** 右端に表示される追加要素 */
  sideItem?: React.ReactNode;
}

/** セクションタイトル */
export const SectionTitle = ({
  children,
  border,
  mb,
  sideItem,
}: SectionTitleProps) => {
  return (
    <div
      className={classNames(styles['jobSearchDetail-sectionTitle'], {
        [styles['jobSearchDetail-sectionTitle--border']]: border,
        [styles['jobSearchDetail-sectionTitle--mb-S']]: mb === 'S',
        [styles['jobSearchDetail-sectionTitle--mb-M']]: mb === 'M',
        [styles['jobSearchDetail-sectionTitle--mb-L']]: mb === 'L',
      })}
    >
      <SectionTitleIO bgType="none" size="XL" as="h2">
        {children}
      </SectionTitleIO>
      {sideItem}
    </div>
  );
};
